<template>
  <div class="electron-info">
    <div class="loading-container">
      <div v-if="loading" class="loading-spinner">
        <div class="spinner"></div>
        <div class="loading-text">加载页面中...</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';

// 使用ref创建响应式变量
const isElectron = ref(false);
const platform = ref('');
const loading = ref(true);

// 使用nextTick确保DOM已经渲染
nextTick(() => {
  // 检查是否在Electron环境中运行
  const isElectronEnv = !!window.electron;
  isElectron.value = isElectronEnv;
  
  if (isElectronEnv) {
    platform.value = window.electron.platform || '';
    console.log('当前运行在 Electron 环境中');
    console.log('平台:', platform.value);
    console.log('Chrome 版本:', document.getElementById('chrome-version')?.textContent || '未知');
    console.log('Node 版本:', document.getElementById('node-version')?.textContent || '未知');
    console.log('Electron 版本:', document.getElementById('electron-version')?.textContent || '未知');
  } else {
    console.log('当前运行在浏览器环境中');
  }
  
  // // 关闭加载状态
  // setTimeout(() => {
  //   loading.value = false;
  // }, 1000);
});

// 发送消息到主进程
const sendMessageToMain = () => {
  if (isElectron.value && window.electron) {
    try {
      window.electron.send('toMain', { message: '来自渲染进程的消息' });
      console.log('消息已发送到主进程: 来自渲染进程的消息');
    } catch (error) {
      console.error('发送消息失败:', error);
    }
  }
};

// 接收来自主进程的消息
const handleMainMessage = (data) => {
  try {
    console.log('收到主进程消息:', data.message);
  } catch (error) {
    console.error('处理消息失败:', error);
  }
};

onMounted(() => {
  // 使用nextTick确保DOM已经完全挂载
  nextTick(() => {
    if (isElectron.value && window.electron) {
      try {
        // 注册接收主进程消息的监听器
        window.electron.receive('fromMain', handleMainMessage);
      } catch (error) {
        console.error('注册监听器失败:', error);
      }
    }
  });
});

onUnmounted(() => {
  // 在组件卸载时，可以清理一些资源
  // 注意：由于我们使用的是preload脚本中的ipcRenderer.on，
  // 实际上我们无法在这里直接移除监听器
  loading.value = false
});
</script>

<style scoped>
.electron-info {
  margin: 20px;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 150px;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #409EFF;
  animation: spin 1s ease-in-out infinite;
}

.loading-text {
  margin-top: 10px;
  color: #409EFF;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style> 